"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = exports.SelectContent = exports.SelectIcon = exports.SelectRoot = exports.SelectTrigger = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_icons_1 = require("@radix-ui/react-icons");
var RadixSelect = __importStar(require("@radix-ui/react-select"));
var react_1 = require("@stitches/react");
var stitches_config_1 = require("../stitches.config");
exports.SelectTrigger = (0, react_1.styled)(RadixSelect.Trigger, {
    borderStyle: "solid",
    borderWidth: "1px",
    width: "360px",
    textAlign: "left",
    borderRadius: stitches_config_1.theme.shape.borderRadius,
    boxShadow: stitches_config_1.theme.shadows.shadowInner,
    background: stitches_config_1.theme.colors.white,
    color: stitches_config_1.theme.colors.gray12,
    padding: "8px 12px",
    "&::placeholder": {
        color: "red",
        opacity: 1,
    },
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontWeight: 450,
    fontSize: 14,
    lineHeight: "20px",
    fontFamily: "Inter",
    "&[data-disabled]": {
        opacity: 0.5,
        cursor: "not-allowed",
    },
    variants: {
        hasValue: {
            true: {
                color: stitches_config_1.theme.colors.gray12,
            },
            false: {
                color: stitches_config_1.theme.colors.gray11,
            },
        },
        error: {
            true: {
                borderColor: stitches_config_1.theme.colors.red7,
                "&:hover": {
                    borderColor: stitches_config_1.theme.colors.red8,
                },
                "&:focus": {
                    borderColor: stitches_config_1.theme.colors.red9,
                    boxShadowColor: stitches_config_1.theme.colors.error,
                    outline: "none",
                },
            },
            false: {
                borderColor: stitches_config_1.theme.colors.gray7,
                "&:hover": {
                    borderColor: stitches_config_1.theme.colors.gray8,
                },
                "&:focus": {
                    borderColor: stitches_config_1.theme.colors.blue9,
                    boxShadowColor: stitches_config_1.theme.colors.focus,
                    outline: "none",
                },
            },
        },
        fullWidth: {
            true: {
                width: "100%",
            },
        },
    },
    defaultVariants: {},
});
exports.SelectRoot = (0, react_1.styled)(RadixSelect.Root, {
    width: "360px",
    variants: {
        fullWidth: {
            true: {
                width: "100%",
            },
        },
    },
});
exports.SelectIcon = (0, react_1.styled)(RadixSelect.Icon, {
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
});
exports.SelectContent = (0, react_1.styled)(RadixSelect.Content, {
    borderStyle: "solid",
    width: "360px",
    zIndex: 10000000,
    borderWidth: "1px",
    background: stitches_config_1.theme.colors.white,
    borderRadius: stitches_config_1.theme.shape.borderRadius,
    borderColor: stitches_config_1.theme.colors.gray7,
    variants: {
        hasValue: {
            true: {
                color: stitches_config_1.theme.colors.gray12,
            },
            false: {
                color: stitches_config_1.theme.colors.gray11,
            },
        },
        error: {
            true: {
                borderColor: stitches_config_1.theme.colors.red7,
                "&:hover": {
                    borderColor: stitches_config_1.theme.colors.red8,
                },
                "&:focus": {
                    borderColor: stitches_config_1.theme.colors.red9,
                    boxShadowColor: stitches_config_1.theme.colors.error,
                    outline: "none",
                },
            },
            false: {
                borderColor: stitches_config_1.theme.colors.gray7,
                "&:hover": {
                    borderColor: stitches_config_1.theme.colors.gray8,
                },
                "&:focus": {
                    borderColor: stitches_config_1.theme.colors.blue9,
                    boxShadowColor: stitches_config_1.theme.colors.focus,
                    outline: "none",
                },
            },
        },
        fullWidth: {
            true: {
                width: "100%",
            },
        },
    },
});
var className = "select";
function Select(props) {
    var _a, _b;
    return ((0, jsx_runtime_1.jsxs)(exports.SelectRoot, __assign({ required: props.required, value: props.value, onValueChange: props.onChange, disabled: props.disabled }, { children: [(0, jsx_runtime_1.jsxs)(exports.SelectTrigger, __assign({ className: "".concat(className, " ").concat(props.className), fullWidth: props.fullWidth, error: (_a = props.error) !== null && _a !== void 0 ? _a : false, id: props.id, hasValue: props.value != null && props.value.length !== 0 }, { children: [(0, jsx_runtime_1.jsx)(RadixSelect.Value, { placeholder: props.placeholder }), (0, jsx_runtime_1.jsx)(exports.SelectIcon, { children: (0, jsx_runtime_1.jsx)(react_icons_1.ChevronDownIcon, {}) })] })), (0, jsx_runtime_1.jsx)(exports.SelectContent, __assign({ className: "".concat(className, " ").concat(props.className), fullWidth: props.fullWidth, error: (_b = props.error) !== null && _b !== void 0 ? _b : false, hasValue: props.value != null && props.value.length !== 0 }, { children: (0, jsx_runtime_1.jsx)(RadixSelect.Viewport, { children: props.children }) }))] })));
}
exports.Select = Select;
Select.toString = function () { return ".".concat(className); };
//# sourceMappingURL=Select.js.map